import { DataFlagEnum } from './announcement';

export const sectorMap: any = {
  '1': 'ALS',
  '2': 'AMS',
  '3': 'IND',
  '4': 'ALS_E&R',
  '5': 'IND&AMS OM',
  '6': 'Clinical'
};

export const sectorValueMap: any = {
  ALS: '1',
  AMS: '2',
  IND: '3',
  'ALS_E&R': '4',
  'IND&AMS OM': '5',
  Clinical: '6'
};

// 列表页跳转到详情页是否自动唤起给销售弹窗
export const showSalesModalStatus: any = {
  '1': true,
  '2': false
};

export enum ShowSalesModalStatusEnum {
  SHOW = '1',
  HIDE = '2'
}

export const dataFlagList = [
  {
    label: '直销',
    value: DataFlagEnum.directSelling
  },
  {
    label: '经销',
    value: DataFlagEnum.dealer
  }
];
